import { SET_USER_PROFILE, SetUserProfileAC } from "./app.types";

export const setUserProfile: SetUserProfileAC = (payload) => ({
  type: SET_USER_PROFILE,
  payload,
});
